import React, { useState, useEffect } from "react";
import "./StudentInsightModal.css";
import { API_URL } from "../config";

function StudentOverallInsightModal({ assessmentId, netId, isOpen, onClose }) {
  const [insightData, setInsightData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen) {
      async function fetchInsight() {
        try {
          const response = await fetch(
            `${API_URL}/api/student-overall-insight/${assessmentId}/${netId}`
          );
          if (!response.ok) {
            throw new Error("Failed to fetch overall insight");
          }
          const data = await response.json();
          setInsightData(data);
        } catch (error) {
          console.error("Error fetching overall insight:", error);
        } finally {
          setLoading(false);
        }
      }
      fetchInsight();
    }
  }, [isOpen, assessmentId, netId]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        {loading ? (
          <p>Loading overall insight...</p>
        ) : insightData ? (
          <div>
            <h2>Overall Student Insight</h2>

            {/* AI-Generated Fun Insight */}
            <div
              style={{
                marginBottom: "1.5rem",
                padding: "1rem",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                border: "1px solid #e9ecef",
              }}
            >
              <p style={{ margin: 0, fontSize: "1rem", lineHeight: "1.5" }}>
                {insightData.LLM_insight || "No insight available."}
              </p>
            </div>

            {/* Traditional Error Breakdown */}
            {insightData.error_breakdown && (
              <div
                style={{
                  marginBottom: "1rem",
                  fontSize: "0.9rem",
                  color: "#6c757d",
                }}
              >
                <p style={{ margin: 0 }}>{insightData.error_breakdown}</p>
              </div>
            )}

            <p style={{ fontSize: "0.9rem", color: "#6c757d", margin: 0 }}>
              <strong>Total Submissions:</strong>{" "}
              {insightData.total_submissions}
            </p>
          </div>
        ) : (
          <p>Error loading overall insight.</p>
        )}
      </div>
    </div>
  );
}

export default StudentOverallInsightModal;
